// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_header__KxmT7 {
    background-color: #FFFFFF;
}

.table_title__JeVoF {
    font-size: large;
}

.table_title__JeVoF:first-letter {
    text-transform: uppercase;
}

.table_button__hfOwX {
    cursor: pointer;
    font-size: medium;
    color: #00A6A8;
    transition: color 0.2s;
}

.table_button__hfOwX:hover {
    color: black;
}

/* Table */
.table_table__pym08 {
    width: 100%;
    border-collapse: collapse;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0);
}

.table_table__pym08 thead th {
    background-color: #fff;
    color: #333;
    padding: 12px;
    border-bottom: 1px solid #E5E7EB;
    text-align: left;
    font-weight: normal;
}

.table_table__pym08 thead th:first-child {
    text-align: left;
}

.table_table__pym08 thead th:first-letter {
    text-transform: uppercase;
}

.table_table__pym08 thead th:last-child {
    text-align: left;
}

.table_table__pym08 tbody td {
    white-space: nowrap;
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #E5E7EB;
    background-color: #FFFFFF;
    color: #6B7280;
}

.table_table__pym08 tbody td:first-child {
    text-align: left;
}

.table_table__pym08 tbody td:last-child {
    text-align: left;
}

.table_table__pym08 tbody tr:last-child td:first-child,
.table_table__pym08 tbody tr:last-child td:last-child {
    border-bottom: none;
}

.table_table__pym08 tbody td:last-child {
    text-align: left;
}

/* Rounded Borders */
.table_table__pym08 thead th:first-child {
    border-top-left-radius: 8px;
}

.table_table__pym08 thead th:last-child {
    border-top-right-radius: 8px;
}

.table_table__pym08 tbody tr:last-child td:first-child {
    border-bottom-left-radius: 8px;
}

.table_table__pym08 tbody tr:last-child td:last-child {
    border-bottom-right-radius: 8px;
}

.table_table__pym08 tbody tr:last-child td {
    border-bottom: none !important;
}

.table_tableWithRowHover__PK79J tbody tr {
    transition: background-color 0.15s ease;
}

.table_tableWithRowHover__PK79J tbody tr:hover td {
    background-color: #f3f4f6;
}

* {
    text-decoration: none !important;
}

.table_actionButtons__e5uNz {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.table_actionButtons__e5uNz svg {
    padding-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/table/styles/table.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA,UAAU;AACV;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,gCAAgC;IAChC,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".header {\n    background-color: #FFFFFF;\n}\n\n.title {\n    font-size: large;\n}\n\n.title:first-letter {\n    text-transform: uppercase;\n}\n\n.button {\n    cursor: pointer;\n    font-size: medium;\n    color: #00A6A8;\n    transition: color 0.2s;\n}\n\n.button:hover {\n    color: black;\n}\n\n/* Table */\n.table {\n    width: 100%;\n    border-collapse: collapse;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0);\n}\n\n.table thead th {\n    background-color: #fff;\n    color: #333;\n    padding: 12px;\n    border-bottom: 1px solid #E5E7EB;\n    text-align: left;\n    font-weight: normal;\n}\n\n.table thead th:first-child {\n    text-align: left;\n}\n\n.table thead th:first-letter {\n    text-transform: uppercase;\n}\n\n.table thead th:last-child {\n    text-align: left;\n}\n\n.table tbody td {\n    white-space: nowrap;\n    padding: 12px;\n    text-align: left;\n    border-bottom: 1px solid #E5E7EB;\n    background-color: #FFFFFF;\n    color: #6B7280;\n}\n\n.table tbody td:first-child {\n    text-align: left;\n}\n\n.table tbody td:last-child {\n    text-align: left;\n}\n\n.table tbody tr:last-child td:first-child,\n.table tbody tr:last-child td:last-child {\n    border-bottom: none;\n}\n\n.table tbody td:last-child {\n    text-align: left;\n}\n\n/* Rounded Borders */\n.table thead th:first-child {\n    border-top-left-radius: 8px;\n}\n\n.table thead th:last-child {\n    border-top-right-radius: 8px;\n}\n\n.table tbody tr:last-child td:first-child {\n    border-bottom-left-radius: 8px;\n}\n\n.table tbody tr:last-child td:last-child {\n    border-bottom-right-radius: 8px;\n}\n\n.table tbody tr:last-child td {\n    border-bottom: none !important;\n}\n\n.tableWithRowHover tbody tr {\n    transition: background-color 0.15s ease;\n}\n\n.tableWithRowHover tbody tr:hover td {\n    background-color: #f3f4f6;\n}\n\n* {\n    text-decoration: none !important;\n}\n\n.actionButtons {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n}\n\n.actionButtons svg {\n    padding-right: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `table_header__KxmT7`,
	"title": `table_title__JeVoF`,
	"button": `table_button__hfOwX`,
	"table": `table_table__pym08`,
	"tableWithRowHover": `table_tableWithRowHover__PK79J`,
	"actionButtons": `table_actionButtons__e5uNz`
};
export default ___CSS_LOADER_EXPORT___;
